import SignupPage from "@/app/register/pages/SignupPage.vue";
import RegisterPage from "@/app/register/pages/RegisterPage.vue";
import RegisterNewUserPage from "@/app/register/pages/RegisterNewUserPage.vue";
import TokenExpired from "@/app/register/components/templates/TokenExpired.vue";
import TokenInvalid from "@/app/register/components/templates/TokenInvalid.vue";

export default [
  {
    path: "/register",
    name: "signup",
    component: SignupPage,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: true,
    },
  },
  {
    path: "/register/:token",
    name: "register",
    component: RegisterPage,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: true,
    },
  },
  {
    path: "/user/register/:token",
    name: "registerNewUSer",
    component: RegisterNewUserPage,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: true,
    },
  },
  {
    path: "/token/expired",
    name: "TokenExpired",
    component: TokenExpired,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: false,
    },
  },
  {
    path: "/token/invalid",
    name: "TokenInvalid",
    component: TokenInvalid,
    meta: {
      requiresAuth: false,
      layout: "footer",
      hideClouds: false,
    },
  },
];
